export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-special-rich-text/index.js